<div class="flex items-center gap-1 py-1 text-xs text-neutral-900 sticky top-0 bg-white z-10">
  <span class="font-semibold"> Resources changed </span>
  @if (!loading() && !emptyMessage()) {
    <p class="ml-auto bg-neutral-100 rounded-full px-2 py-px">
      <strong>{{ resourceChangedNumber() }}</strong>
    </p>
  }
</div>
@if (loading()) {
  <div class="flex items-center justify-center py-4">
    <flx-spinner [size]="'small'"></flx-spinner>
  </div>
} @else if (emptyMessage()) {
  <span class="text-xs text-neutral-500 py-2">{{ emptyMessage() }}</span>
} @else {
  @for (group of versionResourceChangeStatusOrder; track $index) {
    @let items = versionResourcesWithTranslations()[group];
    @if (items) {
      @for (item of items; track $index) {
        @let testResourceName =
          item['metadataType']
            ? item['metadataType']
            : item['resourceType'] + '-' + item['resourceName'];
        <div
          [attr.data-testId]="'resource-path-' + testResourceName"
          class="flex items-center group gap-x-2.5 py-1 relative border-b border-neutral-50"
        >
          <div
            [class.bg-green-400]="group === 'ADDED'"
            [class.bg-yellow-500]="group === 'UPDATED'"
            [class.bg-red-400]="group === 'DELETED'"
            [attr.data-testId]="'resource-status-' + testResourceName"
            class="w-[3px] h-3.5 flex-none rounded-[2px]"
          ></div>
          <div
            [pTooltip]="item.breadcrumb + item.name"
            [showOnEllipsis]="true"
            class="text-xs text-neutral-500 truncate"
            tooltipStyleClass="text-xs"
            tooltipPosition="bottom"
          >
            <span>{{ item.breadcrumb }}</span>
            <strong class="font-semibold">{{ item.name }}</strong>
          </div>

          @if (showCompareButton()) {
            <div class="hidden group-hover:block ml-auto mr-2">
              <button
                (click)="selectResourceForCompare(item, group)"
                class="flx-ds small neutral -m-2"
                variant="text"
                icon="center"
                flxButton
                data-testId="open-compare-resource-btn"
              >
                <i
                  class="ph ph-arrows-left-right"
                  flxIcon
                ></i>
              </button>
            </div>
          }
        </div>
      }
    }
  }
}
